<template>
    <div class="position-box">
      <div class="head">
        <img class="logo" src="@/assets/logo.png" alt="">
        <div class="ads">Link address</div>
      </div>
      <div class="cotainer">
          <div class="img-box"><img class="img" src="@/assets/yanzi/img.png" alt=""></div>
          <div class="t1">Capital verification certification</div>
          <div class="t2">Please click on the link in the upper right corner and click on Capital Verification</div>
          <div class="btn-capital" @click="jump">Capital Verification</div>
          <div class="partners-box">
            <ul class="partners-ul">
              <li class="line"></li>
              <li class="text">Partners</li>
              <li class="line"></li>
            </ul>
            <img class="img-capital" src="@/assets/yanzi/zzs.png" alt="">
          </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'capital',
    data () {
        return {
          theme: false,
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    methods: {
      jump(){
          this.$router.push('/verification')
      },
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1.6rem;
        padding: .36rem .54rem;
        box-sizing: border-box;
        background: #fff;
    }
    .head .logo{
      height: .7rem;
    }
    .head .ads{
      padding: .26rem .3rem;
      color: #fff;
      font-size: .34rem;
      border-radius: .1rem;
      background: #218adc;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .28rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
        text-align: center;
    }
    .cotainer .img-box{
      padding: 1.5rem 0 1.45rem;
    }
    .cotainer .img-box .img{
      width: 6.3rem;
    }
    .cotainer .t1{
      color: #000;
      font-size: .72rem;
    }
    .cotainer .t2{
      padding: 1rem 0 1.2rem;
      color: #000;
      font-size: .3rem;
    }
    .btn-capital{
      width: 7.65rem;
      height: 1.32rem;
      margin: auto;
      color: #fff;
      font-size: .48rem;
      line-height: 1.32rem;
      background: #4458ed;
      border-radius: 0.66rem;
      border: 1px solid #e4e4e4;
      text-align: center;
    }
    .partners-box{
      padding: .66rem 0 1.1rem;
      background: #fff;
      text-align: center;
    }
    .partners-box .partners-ul{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 1.12rem;
    }
    .partners-box .partners-ul .line{
      width: 1.52rem;
      height: 1px;
      background: #4d8afe;
    }
    .partners-box .partners-ul .text{
      padding: 0 .54rem;
      color: #000;
      font-size: .48rem;
    }
    .partners-box .img-capital{
      width: 8.8rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/capital/capital.vue